import React, { useEffect } from 'react';
import CookieConsent from 'react-cookie-consent';
import { getAnalyticsData, COOKIE_AGREE } from '../../common/helpers/CookieHelper';

import { IPageContext } from '../../common/interfaces/pagecontext.interface';

interface Props {
  toggleToggles: () => void;
  cookieName?: string;
  pageContext: IPageContext;
}

const CookiesAgreement = ({ toggleToggles, cookieName = COOKIE_AGREE, pageContext }: Props) => {
  const { Agree, BannerContent } = pageContext.cookiesBanner;
  const { marketingSiteUrl } = pageContext;

  const hideAgreement = async () => {
    toggleToggles();
  };

  useEffect(() => {
    async function updateAnalyticsData() {
      const analyticsData = await getAnalyticsData();

      (window as any).dataLayer?.push({
        event: 'route_changed',
        ...analyticsData,
      });
    }

    updateAnalyticsData();
  }, []);

  return (
    <CookieConsent
      disableStyles
      containerClasses="privacy-cookies-container"
      buttonText={Agree}
      cookieName={cookieName}
      buttonClasses="privacy-cookies-button"
      contentClasses="privacy-cookies-content"
      buttonWrapperClasses="privacy-cookies-button-wrapper"
      expires={150}
      hideOnAccept
      onAccept={hideAgreement}
      location="none"
    >
      <p className="privacy-cookies-agreement-paragraph">
        {BannerContent[0].listElement}{' '}
        <a href={`${marketingSiteUrl}/privacy-notice#main-dif`}>{BannerContent[1].listElement}</a>{' '}
        {BannerContent[2].listElement}{' '}
        <a href={`${marketingSiteUrl}/privacy-notice#cookie-dif`}>{BannerContent[3].listElement}</a>
        {BannerContent[4].listElement}
      </p>
    </CookieConsent>
  );
};

export default CookiesAgreement;